import { GetStaticProps } from 'next';
import { PassengersPageId } from '../../../features/app/pages/domain/constants/PageId';
import { createGetStaticPropsWithPage } from '../../../features/app/root/domain/use-cases/createGetStaticPropsWithPage';
import { getStaticPathsForLocales } from '../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { AccountDetailsPage } from '../../../features/account/ui/account-details/AccountDetailsPage';
import { IAccountDetailsPageData } from '../../../features/account/domain/pages/IAccountDetailsPageData';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps: GetStaticProps<IAccountDetailsPageData> =
	createGetStaticPropsWithPage(PassengersPageId.AccountDetails);

export default AccountDetailsPage;
